import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useAuth } from "./AuthProvider";
import { useNotifications } from "./NotificationsProvider";
import json_parser from "../utils/json_parser";
import date_parser from "../utils/date_parser";
import { toast } from "sonner";


const SocketContext = createContext(null);

export const WebsocketProvider = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const { setNotifications, setNotificationsNotRead } = useNotifications();
    const socketRef = useRef(null);
    
    useEffect(() => {
        if (!isAuthenticated) {
            if (socketRef.current) {
                socketRef.current.close()
                socketRef.current = null;
            }
            setNotifications([]);
        }        
        if (isAuthenticated) {
            socketRef.current = new WebSocket(process.env.REACT_APP_BASE_WEBSOCKET_NOTIFICATION_URL)
            socketRef.current.onopen = () => {
                console.log('CONNECTED WEBSOCKET NOTIFICATIONS!');
                const interval =  setInterval(() => {
                    if (isAuthenticated) {
                        if (socketRef.current) {
                            if(socketRef.current.readyState === WebSocket.OPEN) {
                                socketRef.current.send(JSON.stringify({ type: "ping" }));
                                // console.log('PING');
                            }
                        }
                    }
                }, 30000)
                socketRef.current._pingInterval = interval;
            };
            socketRef.current.onmessage = (e) => {
                const data = json_parser(e.data);
                if (data.type === 'pong') {
                    // console.log('PONG');
                } else if (data.type === 'notification') {
                    const parsedDate = date_parser(data.created_at);
                    const newdata = {...data, created_at: parsedDate};
                    setNotifications((prev) => [newdata, ...prev]);
                    setNotificationsNotRead((prev) => {
                        if (!newdata.is_read) {
                            return prev + 1;
                        } else {
                            return prev
                        }
                    })
                    toast.info('Check new notification!');
                }                
            }
            socketRef.current.onclose = () => {
                console.log('DISCONNECTED WEBSOCKET NOTIFICATIONS!');
                try {
                    if (socketRef.current._pingInterval) {
                        socketRef.current._pingInterval = null;
                    }
                } catch (err) {
                    console.log('CLOSED PING/PONG INTERVAL');
                }
            }
        }
    }, [isAuthenticated])

    return (
        <SocketContext.Provider
            value={{}}
        >
            {children}
        </SocketContext.Provider>
    )
}

export const useSocket = () => {
    return useContext(SocketContext);
}